import { ti } from "../libs/i18n-helpers";

const i18nHelpersPlugin = {
    install(Vue) {
        Vue.prototype.$ti = ti;
    },
};

export default i18nHelpersPlugin;
